/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequestErrorDto,
  GetCitizenshipsResponseDto,
  InternalErrorDto,
  NotFoundErrorDto,
  ServiceUnavailableErrorDto,
  TravelineCititesResponseDto,
  TravelineRegionsResponseDto,
  UnprocessableEntityErrorDto,
} from '../models/index';
import {
    BadRequestErrorDtoFromJSON,
    BadRequestErrorDtoToJSON,
    GetCitizenshipsResponseDtoFromJSON,
    GetCitizenshipsResponseDtoToJSON,
    InternalErrorDtoFromJSON,
    InternalErrorDtoToJSON,
    NotFoundErrorDtoFromJSON,
    NotFoundErrorDtoToJSON,
    ServiceUnavailableErrorDtoFromJSON,
    ServiceUnavailableErrorDtoToJSON,
    TravelineCititesResponseDtoFromJSON,
    TravelineCititesResponseDtoToJSON,
    TravelineRegionsResponseDtoFromJSON,
    TravelineRegionsResponseDtoToJSON,
    UnprocessableEntityErrorDtoFromJSON,
    UnprocessableEntityErrorDtoToJSON,
} from '../models/index';

export interface GetAvailableCitiesInCountryRequest {
    countryCode: string;
}

export interface GetAvailableRegionsInCountryRequest {
    countryCode: string;
}

export interface GetCitiesInCountryRequest {
    countryCode: string;
}

export interface GetCitizenshipsRequest {
    page?: number;
    size?: number;
    local?: string;
}

/**
 * 
 */
export class GeoApi extends runtime.BaseAPI {

    /**
     * Search cities by country code. Returns only cities that are in regions defined in backend properties
     * Search available cities by country code
     */
    async getAvailableCitiesInCountryRaw(requestParameters: GetAvailableCitiesInCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelineCititesResponseDto>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getAvailableCitiesInCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/geo/countries/{countryCode}/availableCities`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelineCititesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Search cities by country code. Returns only cities that are in regions defined in backend properties
     * Search available cities by country code
     */
    async getAvailableCitiesInCountry(requestParameters: GetAvailableCitiesInCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelineCititesResponseDto> {
        const response = await this.getAvailableCitiesInCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search regions by country code. Returns only regions that are in regions defined in backend properties
     * Search available regions by country code
     */
    async getAvailableRegionsInCountryRaw(requestParameters: GetAvailableRegionsInCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelineRegionsResponseDto>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getAvailableRegionsInCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/geo/countries/{countryCode}/availableRegions`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelineRegionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Search regions by country code. Returns only regions that are in regions defined in backend properties
     * Search available regions by country code
     */
    async getAvailableRegionsInCountry(requestParameters: GetAvailableRegionsInCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelineRegionsResponseDto> {
        const response = await this.getAvailableRegionsInCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search cities by country code
     * Search cities by country code
     */
    async getCitiesInCountryRaw(requestParameters: GetCitiesInCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelineCititesResponseDto>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getCitiesInCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/geo/countries/{countryCode}/cities`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelineCititesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Search cities by country code
     * Search cities by country code
     */
    async getCitiesInCountry(requestParameters: GetCitiesInCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelineCititesResponseDto> {
        const response = await this.getCitiesInCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Возвращает список доступных гражданств с поддержкой пагинации
     * Получение списка гражданств
     */
    async getCitizenshipsRaw(requestParameters: GetCitizenshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCitizenshipsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['local'] != null) {
            queryParameters['local'] = requestParameters['local'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/geo/citizenship`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCitizenshipsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Возвращает список доступных гражданств с поддержкой пагинации
     * Получение списка гражданств
     */
    async getCitizenships(requestParameters: GetCitizenshipsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCitizenshipsResponseDto> {
        const response = await this.getCitizenshipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
